import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';

import { IconmoonFont } from 'vibo-ui/Icon';
import { SpotifyButtonProps } from './interfaces';

import useStyles from './style';

const SpotifyButton: FC<SpotifyButtonProps> = ({
  disabled,
  className,
  onClick,
  text = 'exportToSpotify',
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={classNames('spotifyButton', classes.spotifyButton, className)}
      prefixIcon={IconmoonFont['spotify-16']}
      shape="round"
      size="lg"
      {...rest}
    >
      <span>{t(text)}</span>
    </Button>
  );
};

export default SpotifyButton;
